import { GridColumnType } from "../../../../../components/FinalMolGrid/libs/data/gridColumnType";
import { EditGridColumnType } from "../../../../../components/FinalMolGrid/libs/data/editGridColumnType";
import { FormFieldTypes } from "../../../../../components/forms/libs/data/formFieldType";
import TitleWrapper from "../../../../../components/ui/titlewrapper/TitleWrapper";
import { validationTypes } from "../../../../../components/forms/libs/data/ValidationTypes";
import { isDisabled } from "@testing-library/user-event/dist/cjs/utils/index.js";

export const PricingDetailsData = {
    columns: [
        {
            name: "Package",
            fieldName: "eventPackageName",
            allowShort: false,
            allowEditColumn: true,
            editColumn: {
                editColType: EditGridColumnType.INPUT,
                placeholder: "Package",
                editColFieldName: "Package",
                isDisable: false,
                editColValidation: [
                    { type: "required", message: "Package is required." },
                ],
            },
            colStyle: {
                width: "40%",
                textAlign: "center",
            }
        },
        {
            name: "Price",
            fieldName: "eventPrice",
            colType: GridColumnType.NUMERIC,
            allowEditColumn: true,
            editColumn: {
                editColType: EditGridColumnType.NUMERIC,
                placeholder: "price",
                editColFieldName: "price",
                isDisable: false,
                editColValidation: [
                    { type: "required", message: "Adminsration Fee is required." },
                ],
            },
            colStyle: {
                textAlign: "right",
            },
            allowShort: false
        },
        {
            name: "Action",
            colType: GridColumnType.ACTION,
            defaultAction: {
                allowEdit: true,
                allowDelete: true,
            },
            allowShort: false
        },
    ],
    editSettings: {
        buttons: {
            save: true,
            cancel: true,
            delete: false,
        }
    },
    allowEdit: false,
    handleRowDataUpdate: null,
    OnColumnChangeEdit: null,
    hasChildGridTable: false,
};

export const EditPricingData = {
    name: "EditPricingData",
    initialState: {
        eventPackageName: "",
        eventPrice: 0,
        earlyBird: '0',
        earlyPromotionStartDate: null,
        earlyPromotionendDate: null,
        earlyMaxQuantity: '0',
        superEarlyBird: '0',
        superEarlyPromotionStartDate: null,
        superEarlyPromotionendDate: null,
        superEarlyMaxQuantity: '0',
    },
    section: [
        {
            title: "Edit Pricing Section",
            row: {},
            style: {
                sectionStyle: "verticle-form mb-3 form-card row",
            },
            wrapperTemplate: <TitleWrapper title="Pricing Details" />,
            fields: [
                {
                    id: "eventPackageName",
                    label: "Package",
                    Field_Name: "Package",
                    fieldType: FormFieldTypes.INPUT,
                    dataField: "eventPackageName",
                    fieldSetting: {
                        allowSpace: true,
                        isDisable: true,
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-6 radioStyle col-md-4 ",
                    },
                },
                {
                    id: "eventPrice",
                    label: "Price",
                    Field_Name: "Price",
                    fieldType: FormFieldTypes.NUMERIC,
                    dataField: "eventPrice",
                    fieldSetting: {
                        allowSpace: false,
                        isDisabled: false,
                        placeholder: "$00.00",
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-6 radioStyle col-md-4 ",
                    },
                },
            ],
        },
        {
            title: "Early Bird",
            row: {},
            style: {
                sectionStyle: "verticle-form mb-3 form-card row",
            },
            wrapperTemplate: <TitleWrapper title="Early Bird" />,
            fields: [
                {
                    id: "earlyBird",
                    label: "Early Bird",
                    Field_Name: "Early Bird",
                    fieldType: FormFieldTypes.NUMERIC,
                    dataField: "earlyBird",
                    fieldSetting: {
                        placeholder: "$00.00",
                        allowSpace: false,
                    },
                    // validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-3 col-md-4 validation-left-0",
                    },
                },
                {
                    id: "earlyPromotionStartDate",
                    label: "Promotion Start Date",
                    Field_Name: "Promotion Start Date",
                    fieldType: FormFieldTypes.DATEPICKER,
                    dataField: "earlyPromotionStartDate",
                    fieldSetting: {
                        placeholder: "Select",
                        dateConfig: {
                            minDate: new Date(),
                        },
                    },
                    // validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-3 col-md-4 validation-left-0",
                    },
                },
                {
                    id: "earlyPromotionendDate",
                    label: "Promotion Endt Date",
                    Field_Name: "Promotion Endt Date",
                    fieldType: FormFieldTypes.DATEPICKER,
                    dataField: "earlyPromotionendDate",
                    fieldSetting: {
                        placeholder: "Select",
                        dateConfig: {
                            minDate: new Date(),
                        },
                    },
                    //validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-3 col-md-4 validation-left-0",
                    },
                },
                {
                    id: "earlyMaxQuantity",
                    label: "Max Quantity",
                    Field_Name: "Max Quantity",
                    fieldType: FormFieldTypes.NUMERIC,
                    dataField: "earlyMaxQuantity",
                    fieldSetting: {
                        placeholder: "$00.00",
                        allowSpace: false,
                    },
                    //validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-3 col-md-4 validation-left-0",
                    },
                },
            ],
        },
        {
            title: "Super Early Bird",
            row: {},
            style: {
                sectionStyle: "verticle-form mb-3 form-card row",
            },
            wrapperTemplate: <TitleWrapper title="Super Early Bird" />,
            fields: [
                {
                    id: "superEarlyBird",
                    label: "Super Early Bird",
                    Field_Name: "Super Early Bird",
                    fieldType: FormFieldTypes.NUMERIC,
                    dataField: "superEarlyBird",
                    fieldSetting: {
                        placeholder: "$00.00",
                        allowSpace: false,
                    },
                    //validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-3 col-md-4 validation-left-0",
                    },
                },
                {
                    id: "superEarlyPromotionStartDate",
                    label: "Promotion Start Date",
                    Field_Name: "Promotion Start Date",
                    fieldType: FormFieldTypes.DATEPICKER,
                    dataField: "superEarlyPromotionStartDate",
                    fieldSetting: {
                        placeholder: "Select",
                        dateConfig: {
                            minDate: new Date(),
                        },
                    },
                    //validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-3 col-md-4 validation-left-0",
                    },
                },
                {
                    id: "superEarlyPromotionendDate",
                    label: "Promotion Endt Date",
                    Field_Name: "Promotion Endt Date",
                    fieldType: FormFieldTypes.DATEPICKER,
                    dataField: "superEarlyPromotionendDate",
                    fieldSetting: {
                        placeholder: "Select",
                        dateConfig: {
                            minDate: new Date(),
                        },
                    },
                    // validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-3 col-md-4 validation-left-0",
                    },
                },
                {
                    id: "superEarlyMaxQuantity",
                    label: "Max Quantity",
                    Field_Name: "Max Quantity",
                    fieldType: FormFieldTypes.NUMERIC,
                    dataField: "superEarlyMaxQuantity",
                    fieldSetting: {
                        placeholder: "$00.00",
                        allowSpace: false,
                    },
                    //validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-3 col-md-4 validation-left-0",
                    },
                },
            ],
        },
    ],
    formSetting: {
        // isViewOnly: false,
    },
};
